<template>
  <div v-if="readyToRender">
    <h4>Encaissements</h4>

    <!-- Capture authorizations modal -->
    <capture-auth-modal ref="captureAuthModal"
      v-show="cashingWithAuthToCapture"
      :cashing="cashingWithAuthToCapture"
      @authorizations-captured="onAuthCaptured()">
    </capture-auth-modal>

    <!-- Cancel authorizations modal -->
    <cancel-auth-modal ref="cancelAuthModal"
      v-show="cashingWithAuthToCancel"
      :cashing="cashingWithAuthToCancel"
      @authorizations-canceled="onAuthCanceled()">
    </cancel-auth-modal>

    <div v-if="cashings.hasOwnProperty('data') && cashings.data.length > 0">
      <pagination v-if="paginationNeeded"
                  :current-page="currentPage"
                  :total-pages="totalPages" @click="getPageOnClick">
      </pagination>

      <table class="table table-hover table-borderless table-striped table-condensed table-detailed" cellspacing="0" width="100%">
          <thead>
              <tr>
                  <th>ID</th>
                  <th>Type</th>
                  <th>Montant</th>
                  <th>Crée le</th>
                  <th>Statut</th>
                  <th class="text-center">Opérations</th>
              </tr>
          </thead>
          <tbody >
              <template v-for="(cashing, index) in cashings.data">
                  <item @click="onItemClick(index)"
                      :cashing="cashing"
                      :show-details="idxItemDetails === index"
                      @make-cash-payment.capture="toggleModal($event)"
                      @cashing-deleted="onCashingDeleted()"
                      @cancel-authorizations="initCancelAuthModal($event)"
                      @capture-authorizations="initCaptureAuthModal($event)"
                      :key="'cashing-item-'+index">
                  </item>
                  <item-detail v-if="idxItemDetails === index"
                              :cashing="cashing"
                              :key="'cashing-item-details-' + index">
                  </item-detail>
              </template>
          </tbody>
      </table>

      <pagination v-if="paginationNeeded"
                  :current-page="currentPage"
                  :total-pages="totalPages" @click="getPageOnClick">
      </pagination>
      
      <cash-modal v-if="showModal" @close-cash-payment="toggleModal(null)" :cashing="customer_cashing" @close-modal-after-success="toggleModal(null)"></cash-modal>
    </div>

    <div v-else>
      <hr>
      
      <div class="alert alert-info">
          <i class="fa fa-info-circle"></i> Aucun encaissement n'a encore été réalisé pour ce client
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex"
import Pagination from "components/Pagination"
import Item from '../Cashings/Item'
import ItemDetail from '../Cashings/ItemDetail'
import CashModal from 'components/Cash/CashModal'
import CaptureAuthModal from 'components/Cash/CaptureAuthModal'
import CancelAuthModal from 'components/Cash/CancelAuthModal'

export default {
  name:"Cashings",

  components:{
    Pagination,
    Item,
    ItemDetail,
    CashModal,
    CaptureAuthModal,
    CancelAuthModal
  },

  data() {
    return {
      readyToRender:false,
      idxItemDetails: null,
      showModal:false,
      cashingWithAuthToCapture: null,
      cashingWithAuthToCancel: null
    }
  },

  methods:{
    ...mapActions("cash", [
        "fetchSingleCustomerCashings",
        'set_cashing_waiting_for_payement',
        "customerCashings"
    ]),

    onItemClick (idx) {
        this.idxItemDetails = (this.idxItemDetails !== idx) ? idx : null
    },

    getPageOnClick(event){
      if (event + 1 <= this.totalPages)
      {
        this.fetchSingleCustomerCashings({customers:[this.$route.params.id], page:event + 1, with:"creating_agency;entries;payments;invoices"})
      }
    },

    toggleModal(event) {
        if (event != null) {
          this.showModal = true
          this.customer_cashing = event
          this.set_cashing_waiting_for_payement(event)
        } else {
          this.showModal = false
          this.customer_cashing = null
          this.set_cashing_waiting_for_payement(null)
        }
    },

    initCaptureAuthModal(event) {
      this.cashingWithAuthToCapture = event

      this.$refs.captureAuthModal.showModal()
    },
    
    initCancelAuthModal(event) {
      this.cashingWithAuthToCancel = event

      this.$refs.cancelAuthModal.showModal()
    },

    onAuthCaptured() {
      this.fetchSingleCustomerCashings({customers:[this.$route.params.id], with:"creating_agency;entries;payments;invoices"}).then(() => {
        this.cashingWithAuthToCapture = null

        this.$refs.captureAuthModal.hideModal()
      })
    },

    onAuthCanceled() {
      this.fetchSingleCustomerCashings({customers:[this.$route.params.id], with:"creating_agency;entries;payments;invoices"}).then(() => {
        this.cashingWithAuthToCancel = null

        this.$refs.cancelAuthModal.hideModal()
      })
    },

    onCashingDeleted() {
      this.fetchSingleCustomerCashings({customers:[this.$route.params.id], with:"creating_agency;entries;payments;invoices"})
    }
  },

  computed:{
    ...mapState("cash", [
        "cashings",
        'cashing_created_and_waiting_for_payment'
    ]),

    paginationNeeded () {
      return this.cashings.last_page > 1
    },

    totalPages() {
      return this.cashings.last_page
    },

    currentPage(){
      return this.cashings.current_page - 1
    }
  },

  created() {
    this.fetchSingleCustomerCashings({customers:[this.$route.params.id], with:"creating_agency;entries;payments;invoices"})
          .then(() => this.readyToRender = true)
  },

  watch : {
    cashing_created_and_waiting_for_payment : function (newv, oldv) {
        if (newv != null)
        this.$emit('make-cash-payment', newv)
        this.fetchSingleCustomerCashings({customers:[this.$route.params.id], with:"creating_agency;entries;payments;invoices"})
    },
  }

}
</script>



// WEBPACK FOOTER //
// client/components/Customer/Cashings/Cashings.vue